import React, { useEffect } from 'react';

const ScrollPagination = () => {
  useEffect(() => {
    const handlePaginationClick = () => {
      window.scroll(0, 0);
    };

    const paginationItems = document.querySelectorAll('.rc-pagination-item');
    paginationItems.forEach((item) => {
      item.addEventListener('click', handlePaginationClick);
    });

    return () => {
      paginationItems.forEach((item) => {
        item.removeEventListener('click', handlePaginationClick);
      });
    };
  }, []);

  return null;
};

export default ScrollPagination;
